import camelcaseKeys from 'camelcase-keys';
import { camelCaseToSnakeCase } from '@chargify/formatters';

import { HttpMethod } from '../types';

/**
 * Performs request and transforms response
 * @param {string} url - request url
 * @param {HttpMethod} method - http request method
 * @param {object} requestBody - request body
 * @param {object} headers - request headers
 * @returns {Promise}
 */
export const requestHandler = <R>(
  url: string,
  requestBody: Record<string, any>,
  method: HttpMethod = HttpMethod.GET,
  headers: Record<string, any> = {}
): Promise<R> =>
  new Promise(async (resolve, reject) => {
    const body = (
      requestBody ? JSON.stringify(camelCaseToSnakeCase(requestBody)) : null
    ) as BodyInit | null;
    const response = await fetch(url, {
      body,
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
      method,
    });
    const json = await response.json();
    const data = camelcaseKeys(json, { deep: true });

    if (!response.ok) {
      reject(data);
    }

    resolve(data);
  });
